import React, { useState, useEffect, useContext } from "react";
import { makeStyles } from "@material-ui/styles";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Input from "@material-ui/core/Input";
import InputLabel from "@material-ui/core/InputLabel";
import CloudUploadIcon from "@material-ui/icons/CloudUpload";
import FormButton from "./FormButton";
import { withSnackbar } from "notistack";
import {
  ValidatorForm,
  TextValidator,
  SelectValidator
} from "react-material-ui-form-validator";
import { authWrapper } from "../../../auth";

import SERVER_ADDRESS from "../../../config";
import store from "../../../reduxstore";

const useStyles = makeStyles(theme => ({
  submit: {
    marginTop: theme.spacing(3)
  }
}));
//get basic state for a Dialog
function useDialog() {
  const [open, setOpen] = useState(false);

  function handleClickOpen() {
    setOpen(true);
  }

  function handleClose() {
    setOpen(false);
  }
  return [open, handleClickOpen, handleClose];
}

//Main Component
function EditTiaowenDialogButton(props) {
  const classes = useStyles();
  const [canSubmit, setCansubmit] = useState(true);
  const { goujian } = props;
  const [open, handleClickOpen, handleClose] = useDialog();
  const validateRefs = {
    content: React.createRef(),
    // specification: React.createRef(),
    // content_from: React.createRef(),
    wenxian: React.createRef()
    // goujian: React.createRef()
  };
  //For Create
  let id, name;
  if (goujian) {
    id = goujian.id;
    name = goujian.name;
  }
  const { initFormValue, buttonText, add, button, freshData } = props;

  //wenxianOptions from GoujianCard initial in GoujianList
  const { wenxianOptions } = store.getState();

  //提交条文需要的json
  let initState, submitUrl, method;

  //update
  if (initFormValue) {
    initState = {
      content: initFormValue.content,
      specification: initFormValue.specification,
      content_from: initFormValue.content_from,
      wenxian: initFormValue.wenxian,
      goujian: initFormValue.goujian
    };
    submitUrl = `${SERVER_ADDRESS}/api/tiaowens/${initFormValue.id}/`;
    method = "PATCH";
  }
  //create
  else {
    initState = {
      content: "",
      specification: "",
      content_from: "",
      wenxian: "",
      goujian: id
    };
    submitUrl = `${SERVER_ADDRESS}/api/tiaowens/`;
    method = "POST";
  }

  const [formValue, setFromValue] = useState(initState);
  const handleChange = name => event => {
    setFromValue({ ...formValue, [name]: event.target.value });
  };

  //获取文献选项
  // const wenxianOptions = useWenxianOptions([]);

  //根据表单状态中文献的id获取文献的名称
  const getWenxianNamebyId = id => {
    for (let index = 0; index < wenxianOptions.length; index++) {
      const element = wenxianOptions[index];
      if (element.id === id) {
        return `《${element.name}》`;
      }
    }
    return "文献";
  };

  //submit the form data to the server
  const handleSubmit = (postUrl, formValue, method) => {
    return () => {
      setCansubmit(false);
      console.log("submit formValue");
      fetch(postUrl, {
        method: method,
        headers: {
          Accept: "application/json, text/plain, */*",
          "Content-type": "application/json"
        },
        mode: "cors",
        credentials: "include",
        body: JSON.stringify(formValue)
      })
        .then(res => {
          if (!res.ok) {
            throw Error(res.statusText);
          }
          return res.json();
        })
        .then(data => {
          console.log(data);
          //提交成功后清除上次填写内容
          if (!initFormValue) {
            setFromValue({
              content: "",
              specification: "",
              content_from: "",
              wenxian: "",
              goujian: id
            });
          }

          handleClose();
          //提交成功后的反馈SnackBar
          setCansubmit(true);
          if (freshData) {
            freshData(data);
          }
          props.enqueueSnackbar("构件条文数据提交成功", {
            variant: "success"
          });
        })
        .catch(error => {
          //失败后显示错误SnackBar
          // console.log(error);
          setCansubmit(true);

          props.enqueueSnackbar("提交条文失败,格式不正确或资源不存在", {
            variant: "error"
          });
        });
    };
  };

  const handleBlur = refname => {
    return event => {
      validateRefs[refname].current.validate(event.target.value);
    };
  };

  return (
    <>
      <FormButton
        handleClickOpen={handleClickOpen}
        buttonText={buttonText}
        button={button}
        add={add}
      />

      <Dialog open={open} onClose={handleClose}>
        <DialogTitle>{initFormValue ? "编辑条文" : "新建构件条文"}</DialogTitle>
        <DialogContent>
          {initFormValue ? null : (
            <DialogContentText color="secondary">
              新建一条关于{name}的文献
            </DialogContentText>
          )}

          <ValidatorForm
            onSubmit={handleSubmit(submitUrl, formValue, method)}
            instantValidate={true}
            noValidate
          >
            <TextValidator
              ref={validateRefs.content}
              margin="normal"
              autoFocus
              required
              fullWidth
              multiline
              id="content"
              label="文献原文"
              value={formValue.content}
              onChange={handleChange("content")}
              onBlur={handleBlur("content")}
              validators={["required"]}
              errorMessages={["条文内容不可为空"]}
              helperText="填写条文内容的原始文本"
            />
            <TextField
              margin="normal"
              fullWidth
              multiline
              id="specification"
              label="文献详解"
              value={formValue.specification}
              onChange={handleChange("specification")}
              helperText="条文内容的详细注释"
            />
            <TextField
              margin="normal"
              fullWidth
              multiline
              id="content_from"
              label="章节出处"
              value={formValue.content_from}
              onChange={handleChange("content_from")}
              helperText={`条文在${getWenxianNamebyId(
                formValue.wenxian
              )}中的章节`}
            />
            <SelectValidator
              ref={validateRefs.wenxian}
              margin="normal"
              required
              select
              id="wenxian"
              label="文献出处"
              value={formValue.wenxian}
              onChange={handleChange("wenxian")}
              InputLabelProps={{
                shrink: true
              }}
              onBlur={handleBlur("wenxian")}
              validators={["required"]}
              errorMessages={["必须选择所属文献"]}
              helperText="选择条文所属的文献"
            >
              {wenxianOptions.map(option => {
                let { name, id } = option;
                return (
                  <MenuItem key={id} value={id}>
                    {name}
                  </MenuItem>
                );
              })}
            </SelectValidator>
            <Button
              fullWidth
              variant="contained"
              color="primary"
              type="submit"
              className={classes.submit}
              disabled={!canSubmit}
            >
              {canSubmit ? "提交" : "发送中···"}
            </Button>
          </ValidatorForm>
        </DialogContent>
      </Dialog>
    </>
  );
}

const withSnackbarEditTiaowenDialogButton = withSnackbar(
  EditTiaowenDialogButton
);
const AuthEditTiaowenDialogButton = authWrapper(["教师", "学生"])(
  withSnackbarEditTiaowenDialogButton
);

export default AuthEditTiaowenDialogButton;
